import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const DateField = ({ initialDate, onDateChange, inputClasses }) => {
    const parsedInitialDate = initialDate ? new Date(initialDate) : null;
    const [selectedDate, setSelectedDate] = useState(parsedInitialDate);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        onDateChange(date); // Call the callback function with the selected date
    };

    return (
        <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            className={`form-control ${inputClasses}`}
            dateFormat="MMM dd, yyyy"
        />
    );
};

export default DateField;